/* Domovoi · how wide the page is. A computer's layouts (the canvas's Web boards) light up from 960px wide, on the web
   only: the app is a phone, however its WebView is sized. Side-effect free, so a product may import it. */
import { inShell } from './router.js';

export const WIDE_MQ = '(min-width: 960px)';

/** On a computer, on the web. */
export function isWide() {
  return typeof window !== 'undefined' && !inShell() && !!(window.matchMedia && window.matchMedia(WIDE_MQ).matches);
}

/** Tell `fn(wide)` whenever that changes (a window made narrower). → stop */
export function onWide(fn) {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {};
  const mq = window.matchMedia(WIDE_MQ);
  const h = () => fn(isWide());
  if (mq.addEventListener) mq.addEventListener('change', h); else mq.addListener(h);
  return () => { if (mq.removeEventListener) mq.removeEventListener('change', h); else mq.removeListener(h); };
}
